import {
  Button,
  ButtonProps,
  IconButton,
  lighten,
  styled,
  Switch,
  SwitchProps,
} from '@mui/material';

/** Icon button (guide 7.2): 32px, the theme paints color and hover. */
export const BackButton = styled(IconButton)(({ theme }) => ({
  width: '32px',
  height: '32px',
  marginBottom: theme.palette.tokens.space[2],
  '& span': { fontSize: '28px' },
}));

/* Secondary action (guide 7.2); the theme paints the outlined variant. */
export const DownloadButton = styled((props: ButtonProps) => (
  <Button variant="outlined" {...props} />
))(() => ({
  display: 'flex',
}));

export const IOSSwitch = styled((props: SwitchProps) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 48,
  height: 24,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 2,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(24px)',
      color: theme.palette.common.white,
      '& + .MuiSwitch-track': {
        backgroundColor: '#06DFC2',
        opacity: 1,
        border: 0,
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.5,
      },
    },
    '&.Mui-focusVisible .MuiSwitch-thumb': {
      color: '#06DFC2',
      border: `6px solid ${theme.palette.common.white}`,
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
      color: theme.palette.grey[100],
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: 0.7,
    },
    '&.Mui-checked.Mui-disabled + .MuiSwitch-track': {
      backgroundColor: '#06DFC2',
      opacity: 0.7,
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 20,
    height: 20,
  },
  '& .MuiSwitch-track': {
    borderRadius: 24 / 2,
    backgroundColor: lighten(theme.palette.common.grey, 0.5),
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 500,
    }),
  },
}));

interface OutlinedButtonProps {
  width?: string;
}

export const OutlinedButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== 'width',
})<OutlinedButtonProps>(({ theme }) => ({
  width: '200px',
  display: 'flex',
  border: `1px solid ${theme.palette.secondary.main}`,
  color: theme.palette.secondary.main,
  backgroundColor: 'transparent',
  textTransform: 'lowercase',
  '&:disabled': {
    color: theme.palette.secondary.main,
  },
}));
